import { render, staticRenderFns } from "./InputError.vue?vue&type=template&id=57b27270&"
import script from "./InputError.vue?vue&type=script&lang=ts&"
export * from "./InputError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports